import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import { Commodity } from "../../../models/Commodity";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  commodities: Commodity[];
  setCommodity: (commodity: Commodity) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  commodities,
  setCommodity,
  setShowModal,
  showContextMenu,
}: Props) => {
  const rows: Commodity[] = commodities.map((commodity: Commodity) => ({
    ...commodity,
  }));

  const columnDefs: ColDef[] = [
    {
      field: "CommodityName",
      headerName: "Name",
      minWidth: 20,
      flex: 2,
      cellStyle: cellStyle,
    },
    {
      field: "CommodityTypeName",
      headerName: "Type",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "CommodityColor",
      headerName: "Color",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
      cellRenderer: (params: ICellRendererParams) => {
        const color = params.value;
        if (!color) return null;
        return (
          <div
            style={{
              backgroundColor: color,
              width: "20px",
              height: "20px",
              borderRadius: "50%",
            }}
          />
        );
      },
    },
    {
      field: "IsEnable",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setCommodity,
        data: params.data as Commodity,
        setShowModal: setShowModal,
        edit: false,
        del: true,
        showContextMenu: () =>
          showContextMenu(event, params.data, "commodityContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
